import { combineReducers } from 'redux';

import archiveReducer from './archiveReducer';
import archiveFilterReducer from './archiveFilterReducer';
import devicesFiltersReducer from './devicesFiltersReducer';
import devicesReducer from './devicesReducer';
import deviceManufacturersReducer from './deviceManufacturersReducer';
import deviceAssignmentReasonsReducer from './deviceAssignmentReasonsReducer';
import generalCategoriesReducer from './generalCategoriesReducer';
import devicetypesReducer from './devicetypesReducer';
import historyReducer from './historyReducer';
import infrastructureReducer from './infrastructureReducer';
import licensesFiltersReducer from './licensesFiltersReducer';
import licensesClassifierReducer from './licensesClassifierReducer';
import licensesPaymentReducer from './licensesPaymentReducer';
import licensesReducer from './licensesReducer';
import reviewLicenseFiltersReducer from './reviewLicenseFiltersReducer';
import mobileDevicesFiltersReducer from './mobileDevicesFiltersReducer';
import mobileDevicesReducer from './mobileDevicesReducer';
import typeaheadReducer from './typeaheadReducer';
import userProfileReducer from './userProfileReducer';
import userReducer from './userReducer';
import virtualMachinesFiltersReducer from './virtualMachinesFiltersReducer';
import virtualMachinesReducer from './virtualMachinesReducer';
import usersPermissionsReducer from './usersPermissions';
import usersProfilesInfoReducer from './usersProfilesInfo';
import projectsReducer from './projectsReducer';
import expenseFilterReducer from './expenseFilterReducer';
import usersWithoutComputersFiltersReducer from './noUserComputersFiltersReducer';
import usersWithoutComputersReducer from './usersWithoutComputersReducer';
import { languageReducer } from './languageReducer';
import licenseSettingsReducer from './licenseSettingsReducer';
import myAssetsReducer from './myAssetsReducer';
import employeeAssetsReducer from './employeeAssetsReducer';
import assignCountProfileReducer from './assignCountProfileReducer';
import assignReasonsReducer from './assignReasonsReducer';
import exportGoogleSheetsReducer from './exportGoogleSheetsReducer';

export default combineReducers({
    archiveFilter: archiveFilterReducer,
    projects: projectsReducer,
    assignReasons: assignReasonsReducer,
    history: historyReducer,
    generalCategories: generalCategoriesReducer,
    deviceTypes: devicetypesReducer,
    devices: devicesReducer,
    deviceManufacturers: deviceManufacturersReducer,
    deviceAssignmentReasons: deviceAssignmentReasonsReducer,
    mobileDevices: mobileDevicesReducer,
    infrastructure: infrastructureReducer,
    typeahead: typeaheadReducer,
    user: userReducer,
    devicesFilters: devicesFiltersReducer,
    mobileDevicesFilters: mobileDevicesFiltersReducer,
    licenseSettings: licenseSettingsReducer,
    licensesClassifier: licensesClassifierReducer,
    licensesFilters: licensesFiltersReducer,
    licensesPayment: licensesPaymentReducer,
    myAssets: myAssetsReducer,
    employeeAssets: employeeAssetsReducer,
    archive: archiveReducer,
    licenses: licensesReducer,
    virtualMachines: virtualMachinesReducer,
    VMFilters: virtualMachinesFiltersReducer,
    userData: userProfileReducer,
    usersPermissions: usersPermissionsReducer,
    usersProfilesInfo: usersProfilesInfoReducer,
    assignCountProfile: assignCountProfileReducer,
    usersWithoutComputers: usersWithoutComputersReducer,
    usersWithoutComputersFilters: usersWithoutComputersFiltersReducer,
    expense: expenseFilterReducer,
    exportGoogleSheets: exportGoogleSheetsReducer,
    reviewLicenseFilters: reviewLicenseFiltersReducer,
    language: languageReducer,
});
